import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import * as EndgameNote from "components/pages/game/EndgameNote";
import * as FinishedGameScore from "components/pages/game/FinishedGameScore";
import * as ReplaySummary from "components/pages/game/ReplaySummary";
import { GameType } from "models/GameType";
import React, { ReactNode } from "react";

export interface Props {
  game: GameType;
}
const PointCategories = [
  "Terraform Rating",
  "Milestones",
  "Awards",
  "Cities & Greeneries",
  "Cards",
  "Final Score",
];

export const Component: React.FC<Props> = ({ game }) => {
  const theme = useTheme();

  const renderDivider = () => {
    return (
      <Box sx={{ backgroundColor: "#999999", textAlign: "center" }}>
        <Typography variant="h4" sx={{ mt: 4 }}>
          End of Game Summary
        </Typography>
      </Box>
    );
  };

  const Cell: React.FC<{
    children: ReactNode;
    colSpan?: number;
    isBold?: boolean;
  }> = ({ children, colSpan, isBold = false }) => {
    return (
      <Box
        component="td"
        sx={{
          textAlign: "center",
          padding: theme.spacing(1.25),
          border: `1px solid ${theme.palette.divider}`,
          fontWeight: isBold ? "bold" : "normal",
        }}
        colSpan={colSpan}
      >
        {children}
      </Box>
    );
  };

  return (
    <Box>
      {renderDivider()}
      {game.finalScores !== undefined
        ? FinishedGameScore.Component({ finalScores: game.finalScores })
        : null}
      {game.replay !== undefined ? (
        <ReplaySummary.Component
          isReplay={game.replay.isReplay}
          sourceGameId={game.replay.sourceGameId}
        />
      ) : null}
      <EndgameNote.Component />
    </Box>
  );
};

Component.displayName = "FinishedGameSummary";
